<app-admin-table>
  <thead>
    <tr>
      <th>Priority</th>
      <th>Task</th>
      <th>Lead / Applicant</th>
      <th>Due Date &amp; Time</th>
      <th>Status</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    @for (task of visibleTasks(); track task.id) {
      <tr>
        <td>
          <app-crm-task-priority-badge [priority]="task.priority" size="sm" />
        </td>
        <td class="crm-assigned-tasks-table__task">
          <span class="crm-assigned-tasks-table__task-title">{{ task.title }}</span>
          @if (task.description) {
            <span class="crm-assigned-tasks-table__task-desc">{{ task.description }}</span>
          }
        </td>
        <td>
          <div class="crm-assigned-tasks-table__entity">
            <span class="crm-assigned-tasks-table__avatar" aria-hidden="true">
              {{ initials(task.entityDisplayName) }}
            </span>
            <span class="crm-assigned-tasks-table__entity-copy">
              <span class="crm-assigned-tasks-table__entity-name">{{ task.entityDisplayName }}</span>
              <span class="crm-assigned-tasks-table__entity-role">{{ task.entityRoleLabel }}</span>
            </span>
          </div>
        </td>
        <td>
          @if (task.dueAt) {
            <div
              class="crm-assigned-tasks-table__due"
              [class.crm-assigned-tasks-table__due--overdue]="dueUrgency(task.dueAt) === 'overdue'"
              [class.crm-assigned-tasks-table__due--soon]="dueUrgency(task.dueAt) === 'due-soon'"
              [class.crm-assigned-tasks-table__due--upcoming]="dueUrgency(task.dueAt) === 'upcoming'"
            >
              <span class="crm-assigned-tasks-table__due-line">
                <app-admin-icon name="calendar" [size]="14" />
                {{ task.dueAt | date: 'dd MMM yyyy' }}
              </span>
              <span class="crm-assigned-tasks-table__due-line">
                <app-admin-icon name="clock" [size]="14" />
                {{ task.dueAt | date: 'h:mm a' }}
              </span>
            </div>
          } @else {
            <span class="crm-assigned-tasks-table__muted">—</span>
          }
        </td>
        <td>
          <app-crm-task-status-badge
            [status]="task.status"
            [label]="task.statusLabel"
            size="sm"
          />
        </td>
        <td>
          <a
            class="crm-assigned-tasks-table__open-link"
            [routerLink]="detailRoute(task)"
            [queryParams]="detailQuery(task)"
          >
            Open
            <app-admin-icon name="external-link" [size]="14" />
          </a>
        </td>
      </tr>
    }
  </tbody>
</app-admin-table>
